/**
 * A fresh idempotency key for a money-moving POST: 32 lowercase hex characters from 16 random bytes.
 *
 * It satisfies the backend's `^[A-Za-z0-9_-]{8,64}$`. Generate it ONCE per user intent (e.g. once
 * per start-wizard session) and resend the SAME key on every retry, so a retry after a lost response
 * replays the first result instead of charging twice. `crypto.getRandomValues` rather than
 * `crypto.randomUUID`, which jsdom (and older browsers) lack.
 */
export function newIdempotencyKey(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let key = '';
  for (let i = 0; i < bytes.length; i += 1) {
    key += (bytes[i] + 0x100).toString(16).slice(1);
  }
  return key;
}
